export default "__VITE_ASSET__CwjFBWsP__"